"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StyledItem = /*#__PURE__*/_styledComponents.default.li.withConfig({
  displayName: "ItemBase__StyledItem",
  componentId: "components-web__sc-o0oiv5-0"
})({
  display: 'flex'
});
const Item = _ref => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledItem, {
    ...rest,
    children: children
  });
};
Item.propTypes = {
  /**
   * Item content
   */
  children: _propTypes.default.node.isRequired
};
var _default = exports.default = Item;